import dayjs from 'dayjs';
import styled from 'styled-components';

import Text from '~components/Text';

function ClosedContent({ closedDate }: { closedDate: Date | null | string }) {
  return (
    <Wrapper>
      <img src='https://image.wanted.co.kr/kreditjob/www/tear.png' alt='sad face' />
      <Text typography='bold120_B2'>
        폐업된 기업입니다.
        {closedDate && `(${dayjs(closedDate).format('YYYY.MM.DD')})`}
      </Text>
    </Wrapper>
  );
}

export default ClosedContent;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 48px auto 60px auto;

  & > img {
    width: 120px;
    margin-bottom: 8px;
  }

  & > span {
    color: ${({ theme }) => theme.colors.gray700};
  }
`;
